const getValueForEntryWithType = ({
  entries,
  type,
  short = false,
}: {
  entries: google.maps.GeocoderAddressComponent[];
  type: string;
  short?: boolean;
}): string =>
  entries.find(({ types }) => types.includes(type))?.[
    short ? 'short_name' : 'long_name'
  ] ?? '';

export const getStreetAddressFromGeocoderAddressComponents = (
  entries: google.maps.GeocoderAddressComponent[],
): string =>
  [
    getValueForEntryWithType({
      entries,
      type: 'street_number',
    }),
    getValueForEntryWithType({
      entries,
      type: 'route',
    }),
  ]
    .filter(Boolean)
    .join(' ');

export const getCityFromGeocoderAddressComponents = (
  entries: google.maps.GeocoderAddressComponent[],
): string =>
  (getValueForEntryWithType({
    entries,
    type: 'locality',
  }) ||
    getValueForEntryWithType({
      entries,
      type: 'sublocality',
    }) ||
    getValueForEntryWithType({
      entries,
      type: 'sublocality_level_1',
    }) ||
    getValueForEntryWithType({
      entries,
      type: 'neighborhood',
    }) ||
    getValueForEntryWithType({
      entries,
      type: 'administrative_area_level_3',
    }) ||
    getValueForEntryWithType({
      entries,
      type: 'administrative_area_level_2',
    })) ??
  '';

export const getStateFromGeocoderAddressComponents = (
  entries: google.maps.GeocoderAddressComponent[],
): string =>
  getValueForEntryWithType({
    entries,
    short: true,
    type: 'administrative_area_level_1',
  }) ?? '';

export const getZipCodeFromGeocoderAddressComponents = (
  entries: google.maps.GeocoderAddressComponent[],
): string =>
  getValueForEntryWithType({
    entries,
    type: 'postal_code',
  }) ?? '';

export const getCountyFromGeocorderAddressComponents = (
  entries: google.maps.GeocoderAddressComponent[],
): string =>
  getValueForEntryWithType({
    entries,
    type: 'administrative_area_level_2',
  });
